import React from 'react';
import PropTypes from 'prop-types';
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import TextEditor from "./TextEditor";
import TextRender from "./TextRender";
import {useSelector} from "react-redux";

const TextScreenComponent = (props) => {
    const {
        properties: {label, type, path, multiLanguage, preserveWhitespace},
        styles,
        screenName,
        fromDesigner,
        setValue,
        actionsContext,
        containerArrayPath
    } = props;
    const currentStyles = styles[0];
    const {globalValues} = useSelector(state => state.jsonScreen);
    return (
        type === 'editor' ? (
            <TextEditor
                setValue={setValue}
                globalValues={globalValues}
                screenName={screenName}
                path={path}
                currentStyles={currentStyles}
                disabled={fromDesigner}
                multiLanguage={multiLanguage}
                containerArrayPath={containerArrayPath}
                preserveWhitespace={preserveWhitespace}
            />
        ) : (
            <TextRender
                label={label}
                screenName={screenName}
                globalValues={globalValues}
                currentStyles={currentStyles}
                fromDesigner={fromDesigner}
                actionsContext={actionsContext}
            />
        )
    )
};

export default JsonScreenHoc(TextScreenComponent);

TextScreenComponent.propTypes = {
    properties: PropTypes.object,
    styles: PropTypes.array,
    globalValues: PropTypes.object,
    screenName: PropTypes.string,
    fromDesigner: PropTypes.bool,
    containerArrayPath: PropTypes.string,
};

TextScreenComponent.defaultProps = {
    properties: {},
    styles: [{}],
    globalValues: {},
    screenName: ""
};